import { render, staticRenderFns } from "./BlankLayout.vue?vue&type=template&id=01821e32&scoped=true"
var script = {}
import style0 from "./BlankLayout.vue?vue&type=style&index=0&id=01821e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01821e32",
  null
  
)

export default component.exports